<form #ngForm="ngForm" [formGroup]="form" (validSubmit)="save()">
  @if (pool) {
    <div id="poolTypes">
      <ng-container formGroupName="groupSelections">
        @for (poolGroup of pool.poolGroups; track poolGroup) {
          <h4>
            @for (
              poolType of poolGroup.items;
              track poolType;
              let first = $first
            ) {
              @if (!first) {
                /
              }
              {{ poolType.name }}
            }
          </h4>

          <div class="form-check mb-3">
            <input
              data-dd-action-name="pool-setting-selection.pool-none-radio"
              type="radio"
              id="{{ poolGroup.groupKey }}-none"
              [attr.name]="poolGroup.groupKey"
              class="form-check-input"
              value=""
              [formControlName]="poolGroup.groupKey"
            />
            <label for="{{ poolGroup.groupKey }}-none" class="form-check-label">
              None
            </label>
          </div>

          @for (poolType of poolGroup.items; track poolType) {
            <div class="form-check mb-3">
              <input
                data-dd-action-name="pool-setting-selection.pool-type-radio"
                type="radio"
                id="{{ poolGroup.groupKey }}-{{ poolType.code }}"
                [attr.name]="poolGroup.groupKey"
                class="pool-type form-check-input"
                [formControlName]="poolGroup.groupKey"
                [value]="poolType.code"
              />
              <label
                for="{{ poolGroup.groupKey }}-{{ poolType.code }}"
                class="form-check-label"
              >
                {{ poolType.name }}
              </label>
              @if (poolType.message) {
                <p
                  id="{{ poolType.code }}-message"
                  class="mt-1 text-body-secondary"
                >
                  {{ poolType.message }}
                  @if (poolType.link; as link) {
                    <a
                      data-dd-action-name="pool-setting-selection.pool-type-reference-link"
                      [href]="link"
                      target="_blank"
                      rel="noopener noreferrer"
                      >{{ poolType.linkTitle || 'Reference' }}
                      <i-lucide name="external-link"></i-lucide
                    ></a>
                  }
                </p>
              }
            </div>
          }
        }
      </ng-container>

      <ng-container formGroupName="otherSelections">
        @for (poolItem of pool.pools; track poolItem) {
          <h4>
            {{ poolItem.name }}
          </h4>
          <div class="form-check mb-3">
            <input
              data-dd-action-name="pool-setting-selection.pool-item-checkbox"
              id="{{ poolItem.code }}"
              type="checkbox"
              class="pool-type form-check-input"
              [formControlName]="poolItem.code"
            />
            <label class="form-check-label" for="{{ poolItem.code }}">
              {{ poolItem.name }}
            </label>
            @if (poolItem.message) {
              <p
                id="{{ poolItem.code }}-message"
                class="mt-1 text-body-secondary"
              >
                {{ poolItem.message }}
                @if (poolItem.link; as link) {
                  <a
                    data-dd-action-name="pool-setting-selection.pool-item-reference-link"
                    [href]="link"
                    target="_blank"
                    rel="noopener noreferrer"
                    >{{ poolItem.linkTitle || 'Reference' }}
                    <i-lucide name="external-link"></i-lucide
                  ></a>
                }
              </p>
            }
          </div>
        }
      </ng-container>
    </div>
  }
</form>
